import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export class ApiService {
	protected auth = inject(AuthService);
	protected http = inject(HttpClient);
	protected tokenSimple: string = '9fb3c1e7ad54f28be6d90a7c38d1f4b5e29ac8f71d3e6b42c0fa97db5618ce4f';

	public getPublicHeaders(): HttpHeaders {
		return new HttpHeaders({
			'x-api-key': 'asfsafasfasfasfasfasfasfa',
		});
	}

	public getHeaders(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.auth.getToken(),
		});
	}

	public getHeadersCsv(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.auth.getToken(),
			Accept: 'application/csv',
		});
	}

	public getHeadersFormData(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.auth.getToken(),
		});
	}

	public getHeadersSimple(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.tokenSimple,
		});
	}
}
